import React, { FC } from 'react';

const CarouselCut: FC = () => {
  return (
    <>
      <div className="carousel-cut">
        <CutSvg />
      </div>
      <div className="carousel-cut__content-overlay"></div>
    </>
  );
};

const CutSvg = () => (
  <svg width="100%" height="218" viewBox="0 0 1680 218" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0L1680 218H0V0Z" fill="white" />
    <path d="M0 0L1680 218L0 62.4445V0Z" fill="#D1D2D4" />
  </svg>
);

export default CarouselCut;
